import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiService} from '../api/api.service';
import {QueryParamBuilder} from '../utils/query-param-builder';

import {AggregatesQueryParams} from './aggregates.model';

@Injectable()
export class AggregatesService {
  constructor(private api: ApiService) {

  }

  public fetchAggregates(type: 'collective' | 'individual',
                         id: number, payPeriodId: number, aggregatesQueryParams?: AggregatesQueryParams): Observable<any> {
    const byType = type === 'collective' ? 'byPaySerie' : 'byContract';
    const queryParamBuilder = new QueryParamBuilder(`/payroll/api/v1/aggregates/${byType}/${id}/payperiod/${payPeriodId}`);
    if (aggregatesQueryParams) {
      Object.keys(aggregatesQueryParams).forEach((key) => queryParamBuilder.add(key, aggregatesQueryParams[key]));
    }

    return this.api.get(queryParamBuilder.build());
  }

  public updateAggregates(type: string, id: number, values: any): Observable<any> {
    let url: string;
    let params = {};

    if (type === 'collective') {
      url = `/payroll/api/v1/paySerieAccu/${id}`;
      params = {
        id: values.id,
        amount: values.value
      };
    } else if (type === 'individual') {
      url = `/payroll/api/v1/payAccu/${id}`;
      params = {
        id: values.id,
        sumValue: values.value
      };
    }

    return this.api.post(url, params);
  }
}
